<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .card: .card--body
          .row
            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Font Sizing
              ul
                li.pad_t--5.pad_b--5.text--size_18 .text--size_18
                li.pad_t--5.pad_b--5.text--size_17 .text--size_17
                li.pad_t--5.pad_b--5.text--size_16 .text--size_16
                li.pad_t--5.pad_b--5.text--size_15 .text--size_15
                li.pad_t--5.pad_b--5.text--size_14 .text--size_14
                li.pad_t--5.pad_b--5.text--size_13 .text--size_13
                li.pad_t--5.pad_b--5.text--size_12 .text--size_12
                li.pad_t--5.pad_b--5.text--size_11 .text--size_11

            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Headings
              ul
                li.pad_t--5.pad_b--5.heading--h1 .heading--h1
                li.pad_t--5.pad_b--5.heading--h2 .heading--h2
                li.pad_t--5.pad_b--5.heading--h3 .heading--h3
                li.pad_t--5.pad_b--5.heading--h4 .heading--h4
                li.pad_t--5.pad_b--5.heading--h5 .heading--h5
                li.pad_t--15.pad_b--5.heading--section .heading--section

            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Text Transform Helper
              ul
                li.pad_t--5.pad_b--5.text__uppercase .text__uppercase
                li.pad_t--5.pad_b--5.text__capitalize .text__capitalize
                li.pad_t--5.pad_b--5.text__lowercase .text__lowercase

          .row.pad_t--60
            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Font weight helper
              ul
                li.pad_t--5.pad_b--5: strong strong or b tag
                li.pad_t--5.pad_b--5: strong.bold__thick strong or b tag with .bold__thick
                li.pad_t--5.pad_b--5: strong.bold__black strong or b tag with .bold__black

            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Font Color helper
              ul
                li.pad_t--5.pad_b--5.text--color_primary .text--color_primary
                li.pad_t--5.pad_b--5.text--color_primary_light .text--color_primary_light
                li.pad_t--5.pad_b--5.text--color_primary_lighter .text--color_primary_lighter
                li.pad_t--5.pad_b--5.text--color_secondary .text--color_secondary
                li.pad_t--5.pad_b--5.text--color_success .text--color_success
                li.pad_t--5.pad_b--5.text--color_success_light .text--color_success_light
                li.pad_t--5.pad_b--5.text--color_warning .text--color_warning
                li.pad_t--5.pad_b--5.text--color_error .text--color_error
                li.pad_t--5.pad_b--5.text--color_grey .text--color_grey
                li.pad_t--5.pad_b--5.text--color_white: span.bg--color_primary .text--color_white

            .col-4
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Color Helper
              ul
                li.pad_t--5.pad_b--5.bg--color_primary.text--color_white .bg--color_primary
                li.pad_t--5.pad_b--5.bg--color_primary_light .bg--color_primary_light
                li.pad_t--5.pad_b--5.bg--color_primary_lighter .bg--color_primary_lighter
                li.pad_t--5.pad_b--5.bg--color_secondary .bg--color_secondary
                li.pad_t--5.pad_b--5.bg--color_success .bg--color_success
                li.pad_t--5.pad_b--5.bg--color_success_light .bg--color_success_light
                li.pad_t--5.pad_b--5.bg--color_warning .bg--color_warning
                li.pad_t--5.pad_b--5.bg--color_error .bg--color_error

          .row.pad_t--60
            .col-6
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Buttons

              .pad_b--15
                .mar_b--10: strong Default Button. Add class .button to button or a tag
                span
                  button.button
                    | .button

              .pad_b--15
                .mar_b--10: strong Available in a few colors
                span
                  button.button.button-primary .button-primary
                span.ml-3
                  button.button.button-primary_light .button-primary_light
                span.ml-3
                  button.button.button-secondary .button-secondary
                .pad_t--10
                  span
                    button.button.button-neutral .button-neutral
                  span.ml-3
                    button.button.button-success .button-success

              .pad_b--15
                .mar_b--10: strong Disabled
                span
                  button(disabled).button.button-primary Button
                span.ml-3
                  button(disabled).button.button-primary_light Button
                span.ml-3
                  button(disabled).button.button-secondary Button
                span.ml-3
                  button(disabled).button.button-neutral Button
                span.ml-3
                  button(disabled).button.button-success Button

              .pad_b--15
                .mar_b--10: strong Larger Buttons
                span
                  button.button.button-primary.button_lg Button
                span.ml-3
                  button.button.button-primary_light.button_lg Button
                span.ml-3
                  button.button.button-secondary.button_lg Button
                span.ml-3
                  button.button.button-neutral.button_lg Button
                span.ml-3
                  button.button.button-success.button_lg Button

              .pad_b--15
                .mar_b--10: strong Standardized Button used in ROP
                span
                  button.button.button-primary.button_standard .button_standard

              .pad_b--15
                .mar_b--10: strong Block Button
                span
                  button.button.button-primary.button_block .button_block

              .pad_b--15
                .mar_b--10: strong Framework Default Buttons (DO NOT USE!)
                span
                  a.btn.btn-primary(href="#") btn-primary
                span.ml-3
                  a.btn.btn-secondary(href="#") btn-secondary
                span.ml-3
                  a.btn.btn-info(href="#") btn-info
                .pad_t--10
                  span
                    a.btn.btn-success(href="#") btn-success
                  span.ml-3
                    a.btn.btn-primary-dark(href="#") btn-primary-dark

            .col-6
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Unordered Lists
              ul.list--unordered.list--unordered_default
                li: strong.bold__thick .list--unordered.list--unordered_default
                li Item #2
                li.nostyle Add <strong class="bold__thick">.nostyle</strong> class to li tag to remove the individual bullets
                li Item #4
              
              .pad_t--15
                ul.list--unordered.list--unordered_circle
                  li: strong.bold__thick .list--unordered.list--unordered_circle
                  li Item #2
                  li Item #3


              .pad_t--15
                ul.list--unordered.list--unordered_icon.tick_secondary
                  li: strong.bold__thick .list--unordered.list--unordered_icon.tick_secondary
                  li Item #2
                  li Item #3

              .pad_t--15
                ul.list--unordered.list--unordered_icon.tick_success
                  li: strong.bold__thick .list--unordered.list--unordered_icon.tick_success
                  li Item #2
                  li Item #3


              .heading--h5.text__uppercase.mar_b--15.pad_b--5.mar_t--30(style="border-bottom: 1px solid #ddd"): strong Ordered Lists

              ol.list--ordered.list--ordered_initial
                li: strong.bold__thick .list--ordered.list--ordered_initial
                li Item #2
                li.nostyle Add <strong class="bold__thick">.nostyle</strong> class to li tag to remove the individual numbers
                li Item #4

              .pad_t--15
                ol.list--ordered.list--ordered_roman
                  li: strong.bold__thick .list--ordered.list--ordered_roman
                  li Item #2
                  li Item #3

              .pad_t--15
                ol.list--ordered.list--ordered_alpha
                  li: strong.bold__thick .list--ordered.list--ordered_alpha
                  li Item #2
                  li Item #3

          .row.pad_t--60
            .col-6
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Links
              ul
                li.pad_t--5.pad_b--5.text--size_16: a(href="#") Default Link style
                li.pad_t--5.pad_b--5.text--size_16.link__primary_light: a(href="#") .link__primary_light
                li.pad_t--5.pad_b--5.text--size_16.link__secondary: a(href="#") .link__secondary
                li.pad_t--5.pad_b--5.text--size_16.link__neutral: a(href="#") .link__neutral
                li.pad_t--5.pad_b--5.text--size_16.link__light_grey: a(href="#") .link__light_grey
                li.pad_t--5.pad_b--5.text--size_16.link__light_grey_inverse: a(href="#") .link__light_grey_inverse (Hover to white)

            .col-6
              .heading--h5.text__uppercase.mar_b--15.pad_b--5(style="border-bottom: 1px solid #ddd"): strong Modals
              ul
                li.pad_t--5.pad_b--5
                  button.button.button-neutral(@click="$refs.standardModal.show()") Open Standard Modal
                li.pad_t--5.pad_b--5
                  button.button.button-neutral(@click="$refs.noPadModal.show()") Open No padding Modal
                li.pad_t--5.pad_b--5
                  button.button.button-neutral(@click="$refs.noPadIframeModal.show()") Open No padding with full Iframe Modal


            b-modal(ref='standardModal', hide-footer, hide-header)
              .modal--container
                ModalClose(@click.native="$refs.standardModal.hide()")
                strong.text--size_16 This is a Standard Modal
                .pad_t--15
                  p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias facere libero sint, aperiam maiores dolorum voluptatibus laboriosam adipisci perspiciatis beatae modi a, obcaecati saepe ea ab illum reiciendis placeat quisquam.
                  p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias facere libero sint, aperiam maiores dolorum voluptatibus laboriosam adipisci perspiciatis beatae modi a, obcaecati saepe ea ab illum reiciendis placeat quisquam.
              
            b-modal(ref='noPadModal', hide-footer, hide-header)
              .modal--container.no_padding
                ModalClose(@click.native="$refs.noPadModal.hide()")
                strong.text--size_16 This is a No Padding Modal
                .pad_t--15
                  p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias facere libero sint, aperiam maiores dolorum voluptatibus laboriosam adipisci perspiciatis beatae modi a, obcaecati saepe ea ab illum reiciendis placeat quisquam.
                  p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias facere libero sint, aperiam maiores dolorum voluptatibus laboriosam adipisci perspiciatis beatae modi a, obcaecati saepe ea ab illum reiciendis placeat quisquam.

            b-modal(ref='noPadIframeModal', hide-footer, hide-header, size="xl")
              .modal--container.no_padding
                ModalClose(@click.native="$refs.noPadIframeModal.hide()")
                iframe.full_size(src="https://css-tricks.com", frameborder="0")
</template>



<script>
  import ModalClose from '../components/ModalClose';

  export default {
    name: 'Guideline',

    components: {
      ModalClose
    },
  }
</script>




<style lang="scss">  
  [class^="color"] {
    padding: 10px;
  }
</style>
